// Тинты категорий. Сами цвета лежат в styles.css (--cat-0..9 и .tint-0..9,
// отдельные значения для светлой и тёмной темы) — здесь только стабильный
// индекс по slug, чтобы одна категория всегда получала один тинт.

export const TINT_COUNT = 10;

// Стабильный pseudo-хеш строки → индекс палитры.
function hashIndex(s: string, mod: number): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h % mod;
}

export function categoryTintIndex(key: string | null | undefined): number {
  if (!key) return 0;
  return hashIndex(key, TINT_COUNT);
}
